import { Box, Link, List, ListItem, Typography } from '@mui/material';
import { FC } from 'react';

export const Step2WooCommerce: FC = () => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				// alignItems: 'center',
				// justifyContent: 'center',
				mt: '20px',
				gap: 2,
			}}
		>
			<Box
				sx={{
					display: 'flex',
					// mt: -2,
					backgroundColor: '#de000024', // '#0092de24',
					borderRadius: '12px',
					padding: '10px',
					height: 'auto',
					// width: { md: '100%', sx: 'auto' },
				}}
			>
				<Typography sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#000000d0', ml: '10px' }}>
					Notice, if your store using blocks on the checkout , full landed will not be supported for
					your store. Please contact&nbsp;
					<Link
						href="mailto:support@easproject.com"
						target="_blank"
						rel="noreferrer"
						sx={{
							color: '#000000d0',
							fontSize: '1rem',
							fontWeight: 'bold',
							textDecoration: 'none',
							'&:hover': {
								textDecoration: 'underline',
							},
						}}
					>
						support@easproject.com
					</Link>
					&nbsp;for more information.
				</Typography>
			</Box>

			<Box
				sx={{
					display: 'flex',
					backgroundColor: '#0092de24',
					borderRadius: '12px',
					p: '20px',
					// mt: '20px',
					// width: '100%',
				}}
			>
				<Typography
					sx={{
						fontSize: '3rem',
						color: '#016193',
						fontFamily: 'monospace',
						mr: 2,
						mt: -1,
						mb: -2,
						fontWeight: 'bold',
						textTransform: 'lowercase',
					}}
				>
					i
				</Typography>
				<Box>
					<Typography
						component="p"
						sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193', p: '0 0 8px 0' }}
					>
						The store can&apos;t be connected directly from the Dashboard.{' '}
					</Typography>
					<Typography
						component="p"
						sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193' }}
					>
						To connect your WooCommerce store
					</Typography>
					<Typography
						component="div"
						sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193' }}
					>
						<List dense>
							<ListItem
								sx={{
									display: 'inline-block',
									p: '0 0  8px 0',
								}}
							>
								1. Install EAS EU and UK Compliance plugin from Wordpress plugin directory&nbsp;
								<Link
									href="https://wordpress.org/plugins/eas-eu-compliance/"
									target="_blank"
									rel="noreferrer"
									sx={{
										color: '#016193',
										fontSize: '1rem',
										fontWeight: 'bold',
										textDecoration: 'none',
										'&:hover': {
											textDecoration: 'underline',
										},
									}}
								>
									EAS EU and UK Compliance.
								</Link>
							</ListItem>

							<ListItem
								sx={{
									display: 'inline-block',
									p: '0 0 8px 0',
								}}
							>
								2. Use API key and API secret keys from &nbsp;
								<Link
									href="/general-settings"
									// target="_blank"
									// rel="noreferrer"
									sx={{
										color: '#016193',
										fontSize: '1rem',
										fontWeight: 'bold',
										textDecoration: 'none',
										'&:hover': {
											textDecoration: 'underline',
										},
									}}
								>
									the General settings menu in the EAS dashboard
								</Link>
								&nbsp;to configure plugin.
							</ListItem>

							<ListItem
								sx={{
									display: 'inline-block',
									p: '0 0 8px 0',
								}}
							>
								3. To ensure your full compliance with EU VAT regulations, we offer complimentary
								assistance with configuring your WooCommerce store. Feel free to reach out to us via
								chat or write to &nbsp;
								<Link
									href="mailto:support@easproject.com"
									target="_blank"
									rel="noreferrer"
									sx={{
										color: '#016193',
										fontSize: '1rem',
										fontWeight: 'bold',
										textDecoration: 'none',
										'&:hover': {
											textDecoration: 'underline',
										},
									}}
								>
									support@easproject.com
								</Link>
								&nbsp;to request assisted installation. Please, be prepared to provide access to the
								store following&nbsp;
								<Link
									href=" https://help.easproject.com/eas-woocommerce-store-access-request"
									target="_blank"
									rel="noreferrer"
									sx={{
										color: '#016193',
										fontSize: '1rem',
										fontWeight: 'bold',
										textDecoration: 'none',
										'&:hover': {
											textDecoration: 'underline',
										},
									}}
								>
									&nbsp;help center article.
								</Link>
							</ListItem>

							<ListItem
								sx={{
									display: 'inline-block',
									p: '0 0 8px 0',
								}}
							>
								4. If you wish to configure store by yourself please follow instructions from EAS
								help center at&nbsp;
								<Link
									href="https://help.easproject.com/eas-for-woocommerce"
									target="_blank"
									rel="noreferrer"
									sx={{
										color: '#016193',
										fontSize: '1rem',
										fontWeight: 'bold',
										textDecoration: 'none',
										'&:hover': {
											textDecoration: 'underline',
										},
									}}
								>
									Configuring WooCommerce store.
								</Link>
							</ListItem>
						</List>
					</Typography>
				</Box>
			</Box>
		</Box>
	);
};
